/**
 * Configuration constants for TAP WebSocket feed updates
 */

// Reconnection delays
export const INITIAL_RECONNECT_DELAY = 1000 // 1s
export const MAX_RECONNECT_DELAY = 30000 // 30s
export const MAX_RECONNECT_ATTEMPTS = 10

// Event batching
export const BATCH_INTERVAL = 2000 // 2s - collect events before invalidating queries

// Deduplication cache
export const MAX_SEEN_URIS = 1000 // Maximum URIs to track for deduplication

// Connection health
export const HEARTBEAT_INTERVAL = 30000 // 30s ping/pong to keep connection alive
